import { all, takeLatest } from "redux-saga/effects";
import * as CONST from "../../Utils/Constant";
import offerListSaga from "./RoomOffers/offerListSaga";
import {
  roomTypeSaga,
  addRoomTypeSaga,
  deleteRoomTypeSaga,
  patchRoomTypeSaga,
  roomTypeNameSaga,
  roomStatusSagagetAllRoomNumberWithID,
  getAllRoomTpyeWithID,
  roomStatusSaga,
  getAllRoomNumberWithID,
  getRoomNumberList,
} from "./Room/roomTypeSaga";
import { addAmenitySaga, deleteAmenitySaga, getAmenitySaga, updateAmenitySaga } from "./Room/amenitySaga";
import {
  addRoomReservationSaga,
  allReservationListExportSaga,
  allBookingLogsListSaga,
  allRoomReservationListSaga,
  exportRoomReservationSaga,
  getByIdRoomReservationSaga,
  patchRoomReservationSaga,
  putRoomReassignSaga,
  roomReservationSaga,
  updateRoomBookingByIdSaga,
  postRecordPaymentSaga,
} from "./RoomReservation/roomReservationSaga";
import {
  fetchroomAvailabilitySaga,
  fetchroomReservationsSaga,
  fetchroomSaga,
  roomNumberDetailSaga,
} from "./Frontdesk/dashboardSaga";
import { getSearchGuestDetailSaga } from "./Guests/guestSearchSaga";
// import { addRestaurantCategorySaga, getRestaurantCategorySaga, updateRestaurantCategorySaga } from "./Restaurant/restaurantSaga";
import {
  addTableSaga,
  deleteTableSaga,
  getByIDTableSaga,
  getTableListSaga,
  putTableSaga,
} from "./Table/TableSaga";
// import {addRestaurantCategorySaga, addRestaurantSubCategorySaga, deleteRestaurantCategorySaga, deleteRestaurantSubCategorySaga, getRestaurantCategorySaga, getRestaurantSubCategorySaga, updateRestaurantCategorySaga, updateRestaurantSubCategorySaga } from "./Restaurant/restaurantSaga";
import {
  addRestaurantCategorySaga,
  addRestaurantSubCategorySaga,
  deleteRestaurantCategorySaga,
  deleteRestaurantSubCategorySaga,
  getRestaurantCategorySaga,
  getRestaurantSubCategorySaga,
  updateRestaurantCategorySaga,
  updateRestaurantSubCategorySaga,
  getRestaurantVariantSaga,
  updateRestaurantVariantSaga,
  addRestaurantVarientSaga,
  deleteRestaurantVarientSaga,
} from "./Restaurant/restaurantSaga";
import {
  addOrderSaga,
  cancelledOrderSaga,
  deleteOrderSaga,
  getOrderListSaga,
  putOrderSaga,
} from "./Order/OrderSaga";
import {
  getDepartmentsSaga,
  addDepartmentSaga,
  updateDepartmentSaga,
  deleteDepartmentSaga,
  getDepartmentsCategorySaga,
  addDepartmentCategorySaga,
  updateDepartmentCategorySaga,
  deleteDepartmentCategorySaga,
  getDepartmentInventorySaga,
  addDepartmentInventorySaga,
  updateDepartmentInventorySaga,
  deleteDepartmentInventorySaga,
} from "./Departments/departmentsSaga";

import {
  addProcurementSaga,
  getProcurementsSaga,
  getProcurementsItemsSaga,
  updateProcurementSaga,
  deleteProcurementSaga,
} from "./Procurements/procurementSaga";

import authSaga from "./authSaga";
import {
  getAllMainReportSaga,
  getFinancialReportSaga,
  getFrontDeskReportSaga,
  getPaymentMethodsReportSaga,
  getRecentNotificationsSaga,
} from "./Dashboard/MainDashboardSaga";
import {
  getDefaultAccessSaga,
  getStaffListSaga,
  getUserAccessSaga,
  updateUserAccessSaga,
} from "./Settings/SettingsSaga";

export default function* root() {
  yield all([takeLatest(CONST.GET_ROOM_TYPE_REQUEST, roomTypeSaga)]);
  yield all([takeLatest(CONST.POST_ROOM_TYPE_REQUEST, addRoomTypeSaga)]);
  yield all([takeLatest(CONST.DELETE_ROOM_TYPE_REQUEST, deleteRoomTypeSaga)]);
  yield all([takeLatest(CONST.PATCH_ROOM_TYPE_REQUEST, patchRoomTypeSaga)]);
  yield all([takeLatest(CONST.GET_OFFERS_LIST_REQUEST, offerListSaga)]);
  yield all([
    takeLatest(
      CONST.GET_ALL_ROOM_NUMBER_WITH_ID_REQUEST,
      getAllRoomNumberWithID
    ),
  ]);
  yield all([
    takeLatest(CONST.GET_ALL_ROOM_TYPE_WITH_ID_REQUEST, getAllRoomTpyeWithID),
  ]);

  // amenity
  yield all([takeLatest(CONST.GET_AMENITY_REQUEST, getAmenitySaga)]);

  //reservation

  yield all([
    takeLatest(CONST.GET_ROOM_BOOKING_LIST_REQUEST, roomReservationSaga),
  ]);
  yield all([
    takeLatest(CONST.POST_ROOM_BOOKING_REQUEST, addRoomReservationSaga),
  ]);
  yield all([
    takeLatest(CONST.PATCH_ROOM_BOOKING_REQUEST, patchRoomReservationSaga),
  ]);
  yield all([takeLatest(CONST.PUT_ROOM_REASSIGN_REQUEST, putRoomReassignSaga)]);
  yield all([
    takeLatest(CONST.GET_BYID_ROOM_BOOKING_REQUEST, getByIdRoomReservationSaga),
  ]);
  yield all([
    takeLatest(CONST.EXPORT_ROOM_BOOKING_REQUEST, exportRoomReservationSaga),
  ]);

  yield all([
    takeLatest(CONST.FETCH_RESERVATION_REQUEST, fetchroomReservationsSaga),
  ]);
  yield all([
    takeLatest(
      CONST.FETCH_ROOM_AVAILABILITY_REQUEST,
      fetchroomAvailabilitySaga
    ),
  ]);
  yield all([takeLatest(CONST.FETCH_ROOM_REQUEST, fetchroomSaga)]);
  yield all([takeLatest(CONST.GET_ROOM_TYPE_NAME_REQUEST, roomTypeNameSaga)]);
  yield all([takeLatest(CONST.GET_ROOM_STATUS_REQUEST, roomStatusSaga)]);
  yield all([
    takeLatest(CONST.GET_ROOM_NUMBER_DETAIL_REQUEST, roomNumberDetailSaga),
  ]);
  yield all([
    takeLatest(
      CONST.GET_ALL_RESERVATION_LIST_REQUEST,
      allRoomReservationListSaga
    ),
  ]);
  yield all([
    takeLatest(
      CONST.GET_RESERVATION_LIST_EXPORT_REQUEST,
      allReservationListExportSaga
    ),
  ]);
  yield all([
    takeLatest(CONST.GET_ALL_BOOKING_LOGS_REQUEST, allBookingLogsListSaga),
  ]);
  yield all([
    takeLatest(
      CONST.PUT_ROOM_BOOKING_DETAILS_REQUEST,
      updateRoomBookingByIdSaga
    ),
  ]);

  // Guest Details
  yield all([
    takeLatest(CONST.GET_GUEST_SEARCH_REQUEST, getSearchGuestDetailSaga),
  ]);

  // Restaurant sagas
  yield all([
    takeLatest(
      CONST.GET_ALL_RESTAURANT_CATEGORY_LIST_REQUEST,
      getRestaurantCategorySaga
    ),
  ]);
  yield all([
    takeLatest(
      CONST.POST_RESTAURANT_CATEGORY_REQUEST,
      addRestaurantCategorySaga
    ),
  ]);
  yield all([
    takeLatest(
      CONST.PUT_RESTAURANT_CATEGORY_REQUEST,
      updateRestaurantCategorySaga
    ),
  ]);

  yield all([takeLatest(CONST.GET_TABLE_LIST_REQUEST, getTableListSaga)]);
  yield all([takeLatest(CONST.POST_TABLE_LIST_REQUEST, addTableSaga)]);
  yield all([takeLatest(CONST.DELETE_TABLE_LIST_REQUEST, deleteTableSaga)]);
  yield all([takeLatest(CONST.GET_BYID_TABLE_LIST_REQUEST, getByIDTableSaga)]);
  yield all([takeLatest(CONST.PUT_TABLE_LIST_REQUEST, putTableSaga)]);
  yield all([
    takeLatest(
      CONST.DELETE_RESTAURANT_CATEGORY_REQUEST,
      deleteRestaurantCategorySaga
    ),
  ]);
  yield all([
    takeLatest(
      CONST.GET_ALL_RESTAURANT_SUB_CATEGORY_LIST_REQUEST,
      getRestaurantSubCategorySaga
    ),
  ]);
  yield all([
    takeLatest(
      CONST.POST_RESTAURANT_SUB_CATEGORY_REQUEST,
      addRestaurantSubCategorySaga
    ),
  ]);
  yield all([
    takeLatest(
      CONST.PUT_RESTAURANT_SUB_CATEGORY_REQUEST,
      updateRestaurantSubCategorySaga
    ),
  ]);
  yield all([
    takeLatest(
      CONST.DELETE_RESTAURANT_SUB_CATEGORY_REQUEST,
      deleteRestaurantSubCategorySaga
    ),
  ]);
  yield all([
    takeLatest(
      CONST.GET_ALL_RESTAURANT_VARIANT_LIST_REQUEST,
      getRestaurantVariantSaga
    ),
  ]);
  yield all([
    takeLatest(
      CONST.PUT_RESTAURANT_VARIANT_REQUEST,
      updateRestaurantVariantSaga
    ),
  ]);
  yield all([
    takeLatest(CONST.POST_RESTAURANT_VARIANT_REQUEST, addRestaurantVarientSaga),
  ]);
  yield all([
    takeLatest(
      CONST.DELETE_RESTAURANT_VARIANT_REQUEST,
      deleteRestaurantVarientSaga
    ),
  ]);

  yield all([takeLatest(CONST.GET_ORDER_LIST_REQUEST, getOrderListSaga)]);
  yield all([takeLatest(CONST.POST_ORDER_LIST_REQUEST, addOrderSaga)]);
  yield all([takeLatest(CONST.PUT_ORDER_LIST_REQUEST, putOrderSaga)]);
  yield all([takeLatest(CONST.DELETE_ORDER_LIST_REQUEST, deleteOrderSaga)]);

  // inventory/departments saga
  yield all([
    takeLatest(CONST.GET_ALL_DEPARTMENT_LIST_REQUEST, getDepartmentsSaga),
  ]);
  yield all([takeLatest(CONST.POST_DEPARTMENT_REQUEST, addDepartmentSaga)]);
  yield all([takeLatest(CONST.PUT_DEPARTMENT_REQUEST, updateDepartmentSaga)]);
  yield all([
    takeLatest(CONST.DELETE_DEPARTMENT_REQUEST, deleteDepartmentSaga),
  ]);

  yield all([
    takeLatest(
      CONST.GET_ALL_DEPARTMENT_CATEGORY_LIST_REQUEST,
      getDepartmentsCategorySaga
    ),
  ]);
  yield all([
    takeLatest(
      CONST.POST_DEPARTMENT_CATEGORY_REQUEST,
      addDepartmentCategorySaga
    ),
  ]);
  yield all([
    takeLatest(
      CONST.PUT_DEPARTMENT_CATEGORY_REQUEST,
      updateDepartmentCategorySaga
    ),
  ]);
  yield all([
    takeLatest(
      CONST.DELETE_DEPARTMENT_CATEGORY_REQUEST,
      deleteDepartmentCategorySaga
    ),
  ]);
  yield all([takeLatest(CONST.CANCELLED_ORDER_REQUEST, cancelledOrderSaga)]);

  yield all([
    takeLatest(
      CONST.GET_ALL_DEPARTMENT_INVENTORY_LIST_REQUEST,
      getDepartmentInventorySaga
    ),
  ]);
  yield all([
    takeLatest(
      CONST.POST_DEPARTMENT_INVENTORY_REQUEST,
      addDepartmentInventorySaga
    ),
  ]);
  yield all([
    takeLatest(
      CONST.PUT_DEPARTMENT_INVENTORY_REQUEST,
      updateDepartmentInventorySaga
    ),
  ]);
  yield all([
    takeLatest(
      CONST.DELETE_DEPARTMENT_INVENTORY_REQUEST,
      deleteDepartmentInventorySaga
    ),
  ]);

  yield all([
    takeLatest(CONST.POST_RECORD_PAYMENT_REQUEST, postRecordPaymentSaga),
  ]);

  // REPORTS SAGAS

  yield all([
    takeLatest(CONST.GET_OFFICE_REPORTS_REQUEST, getFrontDeskReportSaga),
  ]);
  yield all([
    takeLatest(CONST.GET_FINANCIAL_REPORTS_REQUEST, getFinancialReportSaga),
  ]);
  yield all([
    takeLatest(CONST.GET_ALL_MAIN_REPORTS_REQUEST, getAllMainReportSaga),
  ]);
  yield all([
    takeLatest(CONST.GET_PAYMENT_METHODS_REPORT_REQUEST, getPaymentMethodsReportSaga),
  ]);
  yield all([
    takeLatest(CONST.GET_RECENT_NOTIFICATIONS_REQUEST, getRecentNotificationsSaga),
  ]);

  // PROCUREMENT
  yield all([
    takeLatest(CONST.GET_ALL_PROCUREMENT_LIST_REQUEST, getProcurementsSaga),
  ]);
  yield all([takeLatest(CONST.POST_PROCUREMENT_REQUEST, addProcurementSaga)]);
  yield all([takeLatest(CONST.PUT_PROCUREMENT_REQUEST, updateProcurementSaga)]);
  yield all([
    takeLatest(CONST.DELETE_PROCUREMENT_REQUEST, deleteProcurementSaga),
  ]);

  yield all([takeLatest(CONST.GET_ALL_STAFF_LIST_REQUEST, getStaffListSaga)]);
  yield all([
    takeLatest(CONST.GET_USER_ACCESS_LIST_REQUEST, getUserAccessSaga),
  ]);
  yield all([
    takeLatest(CONST.UPDATE_USER_ACCESS_REQUEST, updateUserAccessSaga),
  ]);
  yield all([
    takeLatest(CONST.GET_DEFAULT_ACCESS_REQUEST, getDefaultAccessSaga),
  ]);
  yield all([
    takeLatest(CONST.GET_ROOM_LIST_REQUEST, getRoomNumberList),
  ]);
  yield all([
    takeLatest(CONST.POST_AMENITY_REQUEST, addAmenitySaga),
  ]);
  yield all([
    takeLatest(CONST.PUT_AMENITY_REQUEST, updateAmenitySaga),
  ]);
  yield all([
    takeLatest(CONST.DELETE_AMENITY_REQUEST, deleteAmenitySaga),
  ]);

  yield all([authSaga()]);
}
